import { styled } from '@mui/material/styles';

import { Paper as SharedPaper } from 'shared/components/Paper';

export const Paper = styled(SharedPaper)(({ theme }) => ({
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  width: 'min(400px, 100%)',
  margin: theme.spacing(2),

  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(3),
  },
}));
